import { FunctionComponent, JSX } from "preact";

import * as dateish from '@/dateish';

type LinkProps = Omit<JSX.IntrinsicElements['a'], 'href'>

export const LinkDoY: FunctionComponent<LinkProps & { doy: dateish.DoY }> = (props) => {
  const { doy, children, ...rest } = props;
  // TODO How to merge the className properties...
  return <a href={`/date?doy=${doy}`} { ...rest }>{ children }</a>;
}

export const LinkMoY: FunctionComponent<LinkProps & { moy: dateish.MoY }> = (props) => {
  const { moy, children, ...rest } = props;
  // TODO How to merge the className properties...
  return <a href={`/date?moy=${moy}`} { ...rest }>{ children }</a>;
}
